export default "__VITE_ASSET__b1f36cc8__"